import React from 'react';
import classNames from 'classnames';

import css from './IconReviewStar.module.css';

/**
 * Review star icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean?} props.isFilled is filled with color
 * @param {string} props.label aria-label for svg image
 * @returns {JSX.Element} SVG icon
 */
const IconReviewStar = props => {
  const { className, rootClassName, isFilled, label } = props;
  const filledOrDefault = isFilled ? css.filled : css.root;
  const classes = classNames(rootClassName || filledOrDefault, className);

  return (
    <svg
      className={classes}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <path
        d="M22.938 8.008c-.15-.412-.544-.69-.985-.69H14.38L12.507.758C12.377.31 11.967 0 11.5 0c-.467 0-.88.31-1.006.76L8.618 7.317H1.046c-.442 0-.833.278-.983.69-.15.414-.025.876.314 1.16l5.7 4.75L3.2 21.59c-.16.43-.02.916.346 1.196.362.28.87.29 1.242.02l6.71-4.79 6.713 4.79c.375.27.88.26 1.245-.02.366-.28.504-.765.343-1.196l-2.875-7.67 5.7-4.75c.34-.284.463-.746.315-1.16"
        fillRule="evenodd"
      />
    </svg>
    // <svg
    //   width="45"
    //   height="45"
    //   viewBox="0 0 45 45"
    //   xmlns="http://www.w3.org/2000/svg"
    //   role="img"
    //   aria-label={label}
    //   className={classes}
    // >
    //   <rect x="0.5" y="0.5" width="44" height="44" rx="9.5" fill="white" stroke="#FFE6B3" />
    //   <path d="M21.8838 8.51477C22.0661 8.16927 22.5609 8.16927 22.7432 8.51477L26.6148 15.8529C26.6851 15.9861 26.8132 16.0792 26.9617 16.1049L35.137 17.5194C35.5219 17.586 35.6748 18.0566 35.4026 18.3367L29.62 24.2865C29.515 24.3945 29.4661 24.5451 29.4875 24.6942L30.6686 32.9066C30.7242 33.2932 30.3238 33.5841 29.9733 33.4117L22.5278 29.7508C22.3927 29.6843 22.2343 29.6843 22.0991 29.7508L14.6537 33.4117C14.3031 33.5841 13.9028 33.2932 13.9584 32.9066L15.1394 24.6942C15.1609 24.5451 15.1119 24.3945 15.0069 24.2865L9.22438 18.3367C8.95212 18.0566 9.10502 17.586 9.48994 17.5194L17.6653 16.1049C17.8137 16.0792 17.9419 15.9861 18.0122 15.8529L21.8838 8.51477Z"
    //       fillRule="evenodd"
    //   />
    // </svg>
  );
};

export default IconReviewStar;
